import { React, useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import ThousandSeperator from "../../Utils/ThousandSeperator";
import TF_US from "../../images/calender/png/Combined Shape.png";
import Company from "../../images/noun-investment-2180740_5/png/noun-investment-2180740.png";
import Image from "../../images/Combined Shape_3/png/Combined Shape.png";
import { topCardUrl } from "../../Config/config";
import axios from "axios";
import { UserContext } from "../../Contexts/UserContext";
import useModule from "../../hooks/useModule";
import { TableDataContext } from "../../Contexts/TableDataContext";
import { useCard } from "./useCard";
import { Tooltip } from "antd";

/**
 * The Card component is a functional component that retrieves and sets the details of a card based on
 * the company ID and type.
 */
const Card = () => {
  const { data } = useContext(TableDataContext);
  const [isLoading, setIsLoading] = useState(true);

  const Loading = () => {
    return (
      <div className="w-full bg-[#FFFFFF]">
        <div role="status" className="bg-white">
          <svg
            className="relative top-[0rem] inline mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (data?.length !== 0) {
      setIsLoading(false);
    }
  }, [data]);

  const val = useCard(data);

  return (
    <div className="">
      <div className="sm:full mt-[4.25rem] md:mt-[3rem]  h-full  bg-[#F2F2F2]">
        {/* <div> */}
        <div className="overflow-x-auto lg:grid grid-cols-5 gap-4  px-4 py-[0.7rem] flex xl:overflow-hidden scrollbar-remove">
          {/* ----card1----- */}
          <Tooltip title="Includes Debt and Not Included for Aggregate Deals" >
          <section className="cursor-pointer flex-shrink-0 ">
            <div className="bg-white py-1 px-3 rounded-md  border border-gray-200 overflow-hidden">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4 ">
                  <div className="text-[13pt] leading-[17pt] tracking-[-0.3pt] lg:text-[13px] lg:leading-[17px] font-sans_book_body text-[#2B2A29] lg:tracking-[-0.3px]">
                    Total Funding{" "}
                  </div>
                  {isLoading ? (
                    <Loading />
                  ) : val?.totalFunding != null &&
                    val?.totalFunding != 0 &&
                    val?.totalFunding != "$ 0 M" ? (
                    <div className="flex space-x-1 items-center">
                      <span className="text-[18pt] leading-[19pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]   ">
                        {`$ ${val?.totalFunding} M` ?? "--"}
                      </span>
                    </div>
                  ) : (
                    <div className="font-semibold text-[#A5711A]">--</div>
                  )}
                </div>
                <div className="flex-shrink-0  pl-5 flex items-center justify-center">
                  <img
                    className=" pointer-events-none h-[24px] max-w-[25px]"
                    fill="currentColor"
                    src={Image}
                  />
                </div>
              </div>
            </div>
          </section>
          </Tooltip>
          {/* ----card2----- */}
          <section className="flex-shrink-0">
            <div className=" bg-white px-3 py-1  rounded-md  border border-gray-200 overflow-hidden card-animate">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4">
                  <div className=" text-[13pt] leading-[17pt] tracking-[-0.3pt] lg:text-[13px] lg:leading-[17px] font-sans_book_body text-[#2B2A29] lg:tracking-[-0.3px] ">
                    Latest Round
                  </div>
                  {!isLoading ? (
                    val?.latest_round != null && val?.latest_round != 0 ? (
                      <div className="flex space-x-1 ">
                        <div className=" flex items-center">
                          <span className="text-[18pt] leading-[19pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]  ">
                            {val?.latest_round}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className="font-semibold text-[#A5711A]">--</div>
                    )
                  ) : (
                    <Loading />
                  )}
                </div>
                <div className="flex-shrink-0 pl-5 flex items-center justify-center">
                  <img
                    className=" pointer-events-none h-[22px] max-w-[25px]"
                    src={TF_US}
                  />
                </div>
              </div>
            </div>
          </section>
          {/* ----card3----- */}
          <section className="flex-shrink-0 ">
            <div className=" bg-white px-3 py-1 rounded-md  border border-gray-200 overflow-hidden card-animate card-animate">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4 ">
                  <div className="  text-[13pt] leading-[17pt] tracking-[-0.3pt] lg:text-[13px] lg:leading-[17px] font-sans_book_body text-[#2B2A29] lg:tracking-[-0.3px]">
                    Total Exits
                  </div>
                  {!isLoading ? (
                    val?.totalExits != null &&
                    val?.totalExits != 0 &&
                    val?.totalExits != "$ 0" ? (
                      <div className="flex space-x-1 items-center ">
                        {val?.totalExits === 0 ? (
                          <span className="text-[18pt] leading-[23pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]  ">
                            --
                          </span>
                        ) : (
                          <div className="flex space-x-1 items-center">
                            <span className="text-[18pt] leading-[23pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]   ">
                              {val?.totalExits !== 0 ? `$ ${val?.totalExits} M` : "--"}
                            </span>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="font-semibold text-[#A5711A]">--</div>
                    )
                  ) : (
                    <Loading />
                  )}
                </div>
                <div className="flex-shrink-0 pl-5 flex items-center justify-center">
                  <img
                    className=" pointer-events-none h-[24px] max-w-[25px]"
                    src={Image}
                  />
                </div>
              </div>
            </div>
          </section>
          {/* ----card4----- */}
          <section className="flex-shrink-0 ">
            <div className=" bg-white px-3 py-1 rounded-md  border border-gray-200 overflow-hidden card-animate card-animate">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4 ">
                  <div className="  text-[13pt] leading-[17pt] tracking-[-0.3pt] lg:text-[13px] lg:leading-[17px] font-sans_book_body text-[#2B2A29] lg:tracking-[-0.3px] ">
                    Investors
                  </div>
                  {!isLoading ? (
                    val?.no_of_investors != null &&
                    val?.no_of_investors != 0 ? (
                      <div className="flex space-x-1 ">
                        <div className="flex items-center ">
                          <span className="text-[18pt] leading-[23pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]  ">
                            {val?.no_of_investors}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className="font-semibold text-[#A5711A]">--</div>
                    )
                  ) : (
                    <Loading />
                  )}
                </div>
                <div className="flex-shrink-0 pl-5 flex items-center justify-center">
                  <img
                    className=" pointer-events-none h-[26px] max-w-[25px]"
                    src={Company}
                  />
                </div>
              </div>
            </div>
          </section>
          {/* ----card5----- */}
          <section className="flex-shrink-0 ">
            <div className=" bg-white px-3 py-1 rounded-md  border border-gray-200 overflow-hidden card-animate card-animate">
              <div className="grid grid-cols-5 ">
                <div className="col-span-4 ">
                  <div className="  text-[13pt] leading-[15pt] tracking-[-0.3pt] lg:text-[13px] lg:leading-[17px] font-sans_book_body text-[#2B2A29] lg:tracking-[-0.3px]  ">
                  {`Revenue ${val?.fy !== "--" ? `(FY${val?.fy})` : ''}`}
                  </div>
                  {!isLoading ? (
                    val?.revenue != null && val?.revenue != "₹ 0 Cr" ? (
                      <div className="flex space-x-1 ">
                        <div className="  text-[#A5711A] space-x-1 flex items-center ">
                          <span>
                            <span className="tableTd text-[18pt] leading-[19pt] font-bold lg:text-[17px] lg:leading-[23px] tracking-[-0.3px] text-[#A5711A]  ">
                              {val?.revenue}
                            </span>
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div className="font-semibold text-[#A5711A]">--</div>
                    )
                  ) : (
                    <Loading />
                  )}
                </div>
                <div className="flex-shrink-0  pl-5 flex items-center justify-center">
                  <img
                    className=" pointer-events-none h-[24px] max-w-[25px]"
                    src={Image}
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="border-b-2 border-[#e5e5e5]"></div>
      </div>
    </div>
  );
};

export default Card;
